import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../providers/UserProvider";

export type EeljProps = {
  id: string;
  active: boolean;
  name: string;
  title: string;
  description: string;
  thumb: string;
  ageGroup: string;
  price: number;
  start_date: Date;
  end_date: Date;
  orderStartDate: Date;
  orderEndDate: Date;
  orderLimit: number;
  orderCount: number;
  ITtraining: boolean;
  ITtrainingPrice: number;
  tulburdaraaavah?: boolean;  

}

export const EeljInfo = (props: EeljProps) => {
  const {userBio} = useContext(UserContext);
  const {id, name, ITtraining, ITtrainingPrice, active, title, description, thumb, price, ageGroup, start_date, end_date, orderStartDate, orderEndDate, orderLimit, orderCount} = props;
  const [curDate, setCurDate] = useState(new Date());


  const getDateString = (date: string | Date) => {
    return new Date(date).toISOString().split('T')[0].replaceAll('-', '.');
  }

  const countdownString = useMemo(() => {
    const diff = new Date(orderStartDate).valueOf() - curDate.valueOf();

    const formatDuration = (millis: number) => {
      let date = new Date(millis);
      let parts = [];
  
      if (date.getUTCFullYear() > 1970) {
          let years = date.getUTCFullYear() - 1970;
          parts.push(years, 'жил');
      }
      if (date.getUTCMonth() > 0) { // months start at zero
          let months = date.getUTCMonth();
          parts.push(months, 'сар');
      }
      if (date.getUTCDate() > 1) {
          let days = date.getUTCDate() - 1;
          parts.push(days, 'өдөр');
      }

      parts.push(date.toISOString().substring(11, 19));
      return parts.join(' ');
    }
  
    return formatDuration(diff);
  }, [curDate, orderStartDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurDate(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    }
  }, []);

  return (
    <div>
      <div className="flex gap-6 items-center">
        <p className="font-bold text-lg mx-4 italic">{name}</p>
        <Link to={`/eelj/${id}`} className="underline text-[#08B3EC] text-sm">
          Дэлгэрэнгүй
        </Link>
      </div>
      <div className="border-b border-t border-gray-200 bg-white shadow-sm sm:rounded-lg sm:border cursor-pointer">
        <div className="px-4 py-6 sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:p-8">
          <div className="sm:flex lg:col-span-7">
            <div className="aspect-h-1 aspect-w-1 w-full flex-shrink-0 overflow-hidden rounded-lg sm:aspect-none sm:h-40 sm:w-40">
              <img
                src={thumb}
                alt=""
                className="h-full w-full object-cover object-center sm:h-full sm:w-full"
              />
            </div>
            <div className="mt-6 sm:ml-6 sm:mt-0">
              <h3 className="text-base font-medium text-gray-900">
                <a>{title}</a>
              </h3>
              <p className="mt-2 text-sm font-medium text-gray-900">{price + ITtrainingPrice}₮</p>
              <p className="mt-3 text-sm text-gray-500">{description}</p>
            </div>
          </div>
          <div className="mt-6 lg:col-span-5 lg:mt-0">
            <dl className="grid grid-cols-2 gap-x-6 text-sm">
              <div>
                <dt className="font-medium text-gray-900">Насны ангилал</dt>
                <dd className="mt-3 text-gray-500">
                  <span className="block">{ageGroup}</span>
                </dd>
              </div>
              <div>
                <dt className="font-medium text-gray-900">Хугацаа</dt>
                <dd className="mt-3 space-y-3 text-gray-500">
                  <p>{getDateString(start_date)}-{getDateString(end_date)}</p>
                </dd>
                { curDate < new Date(orderEndDate) && curDate > new Date(orderStartDate) && orderCount < orderLimit &&
                  <div className="mt-10 flex items-center justify-center gap-x-6 mr-2">
                    {userBio ?
                      <Link
                        to={`/payment/${id}`}
                        className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-[white] shadow-sm"
                      >
                        Худалдаж авах
                      </Link>
                      :
                      <Link
                        to={`/login`}
                        className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-[white] shadow-sm"
                      >
                        Нэвтрэх
                      </Link>
                    }
                  </div>
                }
              </div>
            </dl>
          </div>
        </div>
        <div className="border-t border-gray-200 px-4 py-6 sm:px-6 lg:p-8">
          <div className="mt-6" aria-hidden="true">
            <div className="mb-6 grid-cols-4 text-sm font-medium text-gray-600 sm:grid">
              {
                curDate < new Date(orderEndDate) ?
                  curDate > new Date(orderStartDate) ?
                    orderCount < orderLimit ? 
                    <div>Захиалга явагдаж байна</div>
                    :
                    <div>Захиалга дүүрсэн байна</div>
                    :
                    <div>Захиалга эхлэхэд {countdownString} үлдлээ</div>
                  :
                  <div>Захиалга дууссан</div>
              }
            </div>
            <div className="overflow-hidden rounded-full bg-gray-200">
              <div className="h-2 rounded-full bg-indigo-600" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EeljInfo;